module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Waterford-f0c715478dd5ff2a8a874c595fac7886.png";